import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import configureStore from './store/configureStore';
import App from './App';
import { OidcProvider } from 'redux-oidc';
import userManager from './lib/identityserver4/userManager';
import ErrorBoundary from './views/Application/ErrorBoundary';

// Get the application-wide store instance, prepopulating with state from the server where available.
export const store = configureStore();
const container = document.getElementById('root')
const root = createRoot(container!)

root.render(
  <Provider store={store}>
      <BrowserRouter>
        <OidcProvider store={store} userManager={userManager}>
          <ErrorBoundary>
            <App />
          </ErrorBoundary>
        </OidcProvider>
      </BrowserRouter>
  </Provider>
);
